import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { trackPageView } from "services/statsService";
import { NotFound } from "navigation/NotFound";
import { BackTop } from "antd";
import {
  ROUTE_LOGIN,
  ROUTE_DASHBOARD,
  ROUTE_USER_PROFILE,
  ROOT,
  ROUTE_REGISTER,
  ROUTE_HOME,
  ROUTE_WELCOME,
  ROUTE_SIGNUP,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_CATEGORY,
  ROUTE_INFO,
  ROUTE_PAY,
  ROUTE_FACILITY_CALENDAR,
} from "navigation/CONSTANTS";
import PrivateRoute from "./Auth/PrivateRoute";
import LoginPage from "pages/LoginPage/LoginPage";
import SignupPage from "pages/SignupPage/SignupPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage/ForgotPasswordPage";
import RegisterPage from "pages/RegisterPage/RegisterPage";
import CategoryPage from "pages/CategoryPage/CategoryPage";
import InfoPage from "pages/InfoPage/InfoPage";
import TopbarLayout from "layouts/TopbarLayout/TopbarLayout";
import DashboardPage from "pages/DashboardPage/Dashboard";
import SidebarLayout from "layouts/SidebarLayout/SidebarLayout";
import { useDispatch } from "react-redux";
import { ChangeSize } from "redux/actions/appActions";
import MainLayout from "layouts/MainLayout/MainLayout";
import UserProfilePage from "pages/ProfilePage/UserProfile/UserProfilePage";
import HomePage from "pages/HomePage/HomePage";
import WelcomePage from "pages/WelcomePage/WelcomePage";
import FacilityPaymentPage from "pages/FacilityPaymentPage/FacilityPaymentPage";
import FacilityCalendarPage from "pages/FacilityCalendarPage/FacilityCalendarPage";
// Fires a page_view event on every route change
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
  return null;
};

export const RouterConfig = () => {
  const screenSize = useWindowSize();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      ChangeSize({ width: screenSize.width, height: screenSize.height })
    );
  }, [screenSize]);

  return (
    <div>
      <RouteTracker />
      <Switch>
        <Route exact path={[ROOT, "/index.html"]} component={HomePage} />
        <Route exact path={ROUTE_CATEGORY} component={CategoryPage} />
        <Route exact path={ROUTE_INFO} component={InfoPage} />
        <Route exact path={ROUTE_LOGIN} component={LoginPage} />
        <Route exact path={ROUTE_SIGNUP} component={SignupPage} />
        <Route exact path={ROUTE_FORGOT_PASSWORD} component={ForgotPasswordPage} />
        <Route exact path={ROUTE_REGISTER} component={RegisterPage} />
        <Route exact path={ROUTE_WELCOME} component={WelcomePage} />
        <Route exact path={ROUTE_PAY} component={FacilityPaymentPage} />
        <Route exact path={ROUTE_FACILITY_CALENDAR} component={FacilityCalendarPage} />
        <PrivateRoute exact path={ROUTE_DASHBOARD} component={DashboardPage} />
        <Route path="*" component={NotFound} />
        {/* <SidebarLayout>
          <TopbarLayout>
            <MainLayout>
              <Switch>
                <PrivateRoute
                  exact path={ROOT}
                  component={DashboardPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_DASHBOARD}
                  component={DashboardPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_USER_PROFILE}
                  component={UserProfilePage}
                />
                <Route path="*" component={NotFound} />
              </Switch>
              <BackTop />
            </MainLayout>
          </TopbarLayout>
        </SidebarLayout> */}
      </Switch>
    </div>
  );
};

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}
